module.exports = "<div class=\"home-container move-content\">\n\n  <router-outlet></router-outlet>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/home/home.component.html
// module id = ../../../../../src/app/home/home.component.html
// module chunks = main